import { colorOpacity, customTheme } from 'theme';

import { TabStyles } from './types';

export const defaultStyles: TabStyles = {
  tabs: {
    size: 'md',
    w: 'full',
    h: 'full',
    display: 'flex',
    flexDirection: 'column',
  },
  tabList: {
    borderBottom: '1px solid',
    borderColor: 'gray.100',
  },
  tab: {
    pb: 0,
    pt: 0,
    px: 0,
    bg: 'transparent',
    borderBottom: '1px solid',
    borderColor: 'transparent',
    _hover: { color: 'primary' },
    _focus: {
      outline: 'none',
      bg: 'transparent',
    },
    _active: {
      outline: 'none',
      bg: colorOpacity(customTheme.colors.primary, 0.1),
    },
    _selected: {},
  },
  tabPanel: {
    flex: 1,
    h: 'full',
    px: 0,
    pb: 0,
    pt: 8,
  },
};

export const selectedTabStyles = {
  borderRadius: 6,
  color: 'primary',
  fontWeight: 'lg',
  bg: colorOpacity(customTheme.colors.primary, 0.1),
};
